import * as React from 'react';
import { IconProps } from '../types';

const IcArrowLeft = (props:IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.733 19.546a1.129 1.129 0 0 1-1.591 0l-6.75-6.75a1.129 1.129 0 0 1 0-1.592l6.75-6.75a1.125 1.125 0 0 1 1.591 1.592L6.778 12l5.955 5.954a1.125 1.125 0 0 1 0 1.592Z"
      fill={props?.fill ?? '#232F3E'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.938 12c0 .621-.504 1.125-1.125 1.125H6.125A1.125 1.125 0 0 1 5 12c0-.621.504-1.125 1.125-1.125h13.688c.621 0 1.125.504 1.125 1.125Z"
      fill={props?.fill ?? '#232F3E'}
    />
  </svg>
);

export default IcArrowLeft;